import SearchModule from "./components/SearchModule/SearchModule";
import SearchHistory from "./components/SearchHistory/SearchHistory";
import {AppContainer} from "./components/AppContainer";
import Header from "./components/Header";
import {SpeedInsights} from "@vercel/speed-insights/react"
import {useState} from "react";
import {ThemeProvider} from "styled-components";
import theme from "./theme";

function App() {

    const [lastSearchActionDatetime, setLastSearchActionDatetime] = useState<Date>();

    return (
        <ThemeProvider theme={theme}>
            <AppContainer>
                <Header/>
                <SearchModule setLastSearchActionDatetime={setLastSearchActionDatetime}/>
                <SearchHistory lastSearchActionDatetime={lastSearchActionDatetime}/>
                <SpeedInsights/>
            </AppContainer>
        </ThemeProvider>
    );
}

export default App;
